import { createCrudModule } from "../crud";
import { doctorFormData } from "./formData";

export const doctorQuery = ({ length = "10", sort = "desc", page = 1, name = "", id = "", sort_by = "id" } = {}) => ({
  paginate: page, size: length, sort_order: sort, sort: sort_by, search: name, id,
});

const doctorDetailsPath = ({ id }) => {
  if (id === undefined || id === null || id === "") throw new Error("A doctor id is required.");
  return `doctors/${encodeURIComponent(id)}`;
};

const doctorModule = createCrudModule({
  name: "doctor",
  stateKey: "Doctor",
  endpoint: "doctors",
  operations: {
    create: { body: values => doctorFormData(values), headers: { Accept: "application/json" } },
    update: { method: "POST", body: ({ data }) => doctorFormData(data, true), headers: { Accept: "application/json" } },
    languages: {
      method: "GET", path: "doctors/languages",
      select: response => {
        const data = response?.data?.data ?? response?.data ?? response;
        if (!Array.isArray(data)) throw new Error("Invalid spoken languages response.");
        return data.filter(item => item && (typeof item === "string" || ![false, 0, "0"].includes(item.is_active)))
          .map(item => typeof item === "string" ? item : item.name).filter(Boolean);
      },
    },
    list: { query: doctorQuery },
    details: {
      path: doctorDetailsPath,
      select: response => {
        const payload = response?.data?.data ?? response?.data ?? response;
        const doctor = Array.isArray(payload) ? payload[0] : payload;
        if (!doctor || typeof doctor !== "object") throw new Error("Doctor not found.");
        return doctor;
      },
    },
    clinicDoctors: {
      path: ({ id }) => `clinics/${encodeURIComponent(id)}/doctors`,
      select: response => response.data,
    },
  },
});

export default doctorModule;
